import React, { useEffect, useState } from 'react';
import { Form, Input, Button, message, Card } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useNavigate, useLocation } from 'react-router-dom';
import request from '../../api/request';
import { LoginFormData, LoginResponse } from '../../types/auth';
import './index.css';

const Login: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const token = localStorage.getItem('token');
    const userStr = localStorage.getItem('user');

    if (token && userStr) {
      navigate('/dashboard');
    }
  }, [navigate]);

  const onFinish = async (values: LoginFormData) => {
    try {
      setLoading(true);

      const data = await request.post<any, LoginResponse>('/api/auth/login', values, {
        skipGlobalErrorMessage: true,
      });
      if (!data?.access_token || !data?.user) {
        throw new Error('登录响应缺少 token 或用户信息');
      }

      localStorage.setItem('token', data.access_token);
      localStorage.setItem('user', JSON.stringify(data.user));

      const targetPath = location.state?.from?.pathname || '/dashboard';
      message.success('登录成功');
      window.setTimeout(() => {
        window.location.href = targetPath;
      }, 500);
    } catch (error: any) {
      console.error('登录失败:', {
        error: error.message,
        response: error.response?.data,
        timestamp: new Date().toISOString(),
      });
      const responseMessage = error.response?.data?.message;
      const errorText = Array.isArray(responseMessage)
        ? responseMessage.join('，')
        : responseMessage;

      message.error(errorText || error.message || '登录失败，请检查用户名和密码');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-content">
        <Card className="login-card">
          <div className="login-header">
            <h1>后台管理系统</h1>
          </div>
          <Form
            name="login-form"
            onFinish={onFinish}
            size="large"
          >
            <Form.Item
              name="username"
              rules={[{ required: true, message: '请输入用户名' }]}
            >
              <Input
                prefix={<UserOutlined />}
                placeholder="用户名"
                autoComplete="username"
              />
            </Form.Item>
            <Form.Item
              name="password"
              rules={[{ required: true, message: '请输入密码' }]}
            >
              <Input.Password
                prefix={<LockOutlined />}
                placeholder="密码"
                autoComplete="current-password"
              />
            </Form.Item>
            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                loading={loading}
                block
              >
                登录
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </div>
    </div>
  );
};

export default Login;
